/**
 * Компонент для редактирования комментариев к полям конфигурации
 */

import React, { FC, useState } from 'react';
import { Modal, Form, Input, Button, Space } from 'antd';
import { EditOutlined } from '@ant-design/icons';

interface ICommentEditorProps {
  fieldPath: string;
  currentComment: string;
  onSave: (fieldPath: string, comment: string) => void;
}

const CommentEditor: FC<ICommentEditorProps> = ({ fieldPath, currentComment, onSave }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => {
    form.setFieldsValue({ comment: currentComment });
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      onSave(fieldPath, values.comment);
      setIsModalVisible(false);
    } catch (error) {
      // Validation error
    }
  };

  return (
    <>
      <Button
        type="text"
        size="small"
        icon={<EditOutlined />}
        onClick={handleOpen}
        title="Редактировать комментарий"
      />

      <Modal
        title={`Комментарий для поля: ${fieldPath}`}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Отмена
          </Button>,
          <Button key="submit" type="primary" onClick={handleSave}>
            Сохранить
          </Button>
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="comment"
            label="Комментарий"
            initialValue={currentComment}
            rules={[
              {
                max: 500,
                message: 'Комментарий не должен превышать 500 символов'
              }
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Введите комментарий для этого поля (например, описание, допустимые значения и т.д.)"
            />
          </Form.Item>

          <div style={{ color: '#999', fontSize: '12px' }}>
            Комментарии будут сохранены в формате JSON5 и будут видны при редактировании
            конфигурации.
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CommentEditor;
